import { useTranslation } from 'react-i18next';

/**
 * ErrorFallback view component
 * @returns {JSX.Element} The ErrorFallback component
 */
function ErrorFallback() {
  // Hooks
  const { t } = useTranslation();

  return (
    <h1>{t('errorFallback.title')}</h1>
  );
}

export default ErrorFallback;
